/** Formata idade relativa em pt-BR para o selo de atualização. */
export function formatSyncedAgo(syncedAt, now = new Date()) {
    if (syncedAt == null)
        return "Nunca sincronizado";
    const date = typeof syncedAt === "string" ? new Date(syncedAt) : syncedAt;
    if (Number.isNaN(date.getTime()))
        return "Sincronização desconhecida";
    const diffMs = Math.max(0, now.getTime() - date.getTime());
    const minutes = Math.floor(diffMs / 60_000);
    if (minutes < 1)
        return "Atualizado agora";
    if (minutes < 60)
        return `Atualizado há ${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 48)
        return `Atualizado há ${hours} h`;
    const days = Math.floor(hours / 24);
    return `Atualizado há ${days} d`;
}
//# sourceMappingURL=freshness.js.map